import {fabric} from "fabric";
import {materials as imported_materials} from "./materials";
import {captureCanvasToDom, clearCapture} from "./save&Load";

export default class MaterialService {
    store;
    imageEditor;

    constructor(store, imageEditor) {
        this.store = store;
        this.imageEditor = imageEditor;
    }

    setMaterial(id, setSaveState = false) {
        let oldMaterial = this.getMaterial(this.store.material_id);
        if (oldMaterial.onDetach) {
            oldMaterial.onDetach(this, oldMaterial);
        }

        let material = this.getMaterial(id);
        this.store.material_id = id;

        if (!this.store.laminate) {
            this.store.laminate = material.laminatingOptions[0].title;
        }

        if (material.onAttach) {
            material.onAttach(this, material, ()=> {
                if (setSaveState) {
                    window.imageEditor.saveState(`set material`);
                }
            });
        }

        this.oldMaterialId = id;
    }

    getMaterial(id) {
        return materials.find(material => material.id === id);
    }

    listeners;
    replaceBackground_attach(material, callback) {
        let app = this;
        app.store.can_edit_background = false;
        material.last_color = app.store.bg_color;
        let canvas = app.store.canvas;

        app.store.setLoading('processing.material_replaceBackground_attach', '');

        fabric.Image.fromURL(material.options.replaceBackground.src, function(img) {
            function setBackground() {
                let scale = Math.max(app.store.width * 300 / img.width, app.store.height * 300 / img.height);
                let oImg = img.set({
                    scaleX: scale,
                    scaleY: scale,
                    originX: 'center',
                    originY: 'center',
                });

                app.store.bg_image = oImg;
                canvas.setBackgroundImage(oImg).renderAll();
            }

            setBackground();

            app.listeners = {
                'canvas:resize': setBackground,
            };

            canvas.on(app.listeners);

            if (callback) {
                callback();
            }

            app.store.setLoadingFinished('processing.material_replaceBackground_attach');
        });
    }

    replaceBackground_detach(material) {
        if (this.listeners) {
            this.store.canvas.off(this.listeners);
        }
        this.store.can_edit_background = true;
        this.store.canvas.setBackgroundImage(null);
        this.store.bg_color = material.last_color;
        this.store.bg_image = null;
        this.imageEditor.refresh();
    }
}

export const materials = imported_materials;
